import { FilterConfig } from "../../models/FilterConfig";
import { LineofBusiness } from "../../models/LineofBusinessFilterData";

export const PricingFilterConfig: Record<LineofBusiness, FilterConfig[]> = {
  electrical: [
    {
      apiKey: "projectFlag",
      filterLabelKey: "project_flag",
      filterValueKey: "project_flag",
      filterName: "Project Type",
      type: "multi",
      payloadValuekey: "projectFlag",
      cleanable: false,
    },
    {
      apiKey: "division",
      filterLabelKey: "plant",
      filterValueKey: "plant",
      filterName: "District",
      type: "multi",
      payloadValuekey: "division",
    },
    {
      apiKey: "peerGroupName",
      filterLabelKey: "peerGroupName",
      filterValueKey: "peerGroupName",
      filterName: "Peer Group",
      type: "multi",
      payloadValuekey: "peerGroupName",
    },
    {
      apiKey: "bill_customer_id",
      filterLabelKey: "bill_customer_id",
      filterValueKey: "bill_customer_id",
      filterName: "Customer",
      type: "multi",
      payloadValuekey: "bill_customer_id",
    },
    {
      apiKey: "itemid",
      filterLabelKey: "cluster",
      filterValueKey: "cluster",
      filterName: "Item ID",
      type: "multi",
      payloadValuekey: "itemid",
    },
    {
      apiKey: "Description",
      filterLabelKey: "Description",
      filterValueKey: "Description",
      filterName: "Item Description",
      type: "multi",
      payloadValuekey: "Description",
    },
  ],
  plumbing: [
    {
      apiKey: "pc",
      filterLabelKey: "pc",
      filterValueKey: "pc",
      filterName: "Pc",
      type: "single",
      payloadValuekey: "pc",
      cleanable: false,
    },
  ],
};

export const filterDefaultValues: Record<LineofBusiness, any> = {
  electrical: {
    bill_customer_id: [],
    division: [],
    Description: [],
    itemid: [],
    peerGroupName: [],
    projectFlag: ["All"],
  },
  plumbing: {
    home: false,
  },
};
